import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import Styles from './Account.module.scss'
import Avatar from 'common/Avatar/Avatar'
import { RoundedPlatformIcon } from 'components/RoundedPlatformIcon/RoundedPlatformIcon'
import { getInitials } from 'utils'
import { Text } from 'blaze-ui/Text/Text'
import { PropsWithChildren } from 'react'
import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import cx from 'classnames'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'

interface Props extends PropsWithChildren {
  source: ExternalIntegration
  avatarSize?: number
}

export const Account = ({ source, children, avatarSize = 25 }: Props) => {
  const { name, avatar } = extractProfileInfo(source)

  return (
    <div className={Styles.account}>
      <div className={Styles.avatar}>
        <Avatar size={avatarSize} label={getInitials(name)} url={avatar || Silhouette} />
        <div className={cx(Styles.providerIcon, { [Styles.largeAvatar]: avatarSize === 32 })}>
          <RoundedPlatformIcon platform={source.provider} size={16} />
        </div>
      </div>
      <div className={Styles.name}>
        <Text variant="smallList" color="var(--dark-80)">
          {name}
        </Text>
      </div>
      {children}
    </div>
  )
}
